<template>
  <div
    :class="{
      'm-sharebar--fixed': sharebarFixed,
      'm-sharebar--playing-stream': isPlayingStream
    }"
    class="m-sharebar"
  >
    <div
      :class="{ 'm-sharebar__container--show' : isShowShare }"
      class="m-sharebar__container"
    >
      <button
        class="m-sharebar__item share-tag"
        title="分享至 Line"
        @click="sharePopup('line')"
      >
        <img src="https://static.ctwant.com/images/dist/share_line.svg" width="25" height="8" alt="Line 標示圖">
      </button>
      <button
        class="m-sharebar__item fb-share-button share-tag"
        title="分享至 Facebook"
        @click="sharePopup('facebook')"
      >
        <img src="https://static.ctwant.com/images/dist/share_fb.svg" width="9" height="20" alt="Facebook 標示圖">
      </button>
      <button
        class="m-sharebar__item wechat"
        title="分享至 Wechat"
        @mouseenter="wechatShare"
        @click="wechatShareMobile"
        @mouseleave="qrcodePopover.show = false"
      >
        <img src="https://static.ctwant.com/images/dist/share_wechat.svg" width="21" height="18" alt="Wechat 標示圖">
        <div v-show="qrcodePopover.show" :style="qrcodePopover.style" class="e-popover">
          <div class="e-popover__body">
            <div class="e-popover__qr-wrapper">
              <client-only>
                <qrcode :value="`${host}${$route.path}?utm_source=share&utm_medium=微信`" />
              </client-only>
              <p>
                請用微信掃描 QR Code
              </p>
            </div>
          </div>
        </div>
      </button>
      <nuxt-link
        v-if="Object.keys(dataNext).length > 0"
        :to="`/${base}/${dataNext[`${base}_id`]}/`"
        class="m-sharebar__item m-sharebar__item--next"
        title="前往下一篇新聞"
        @mouseenter.native="nextNews"
        @mouseleave.native="nextNewPopover.show = false"
      >
        Next
        <div v-show="nextNewPopover.show" :style="nextNewPopover.style" class="e-popover">
          <div class="e-popover__header">
            下一則新聞：
          </div>
          <div class="e-popover__body">
            {{ dataNext.title }}
          </div>
        </div>
      </nuxt-link>
    </div>
    <button class="m-sharebar-mobile-btn share-tag" title="分享" @click="mobileShare">
      <img :class="{ 'm-sharebar-mobile-btn__img--active': !isShowShare }" src="https://static.ctwant.com/images/dist/share.svg" alt="分享標示圖" class="m-sharebar-mobile-btn__img">
      <img :class="{ 'm-sharebar-mobile-btn__img--active': isShowShare }" src="https://static.ctwant.com/images/dist/xx-gray.svg" alt="關閉分享標示圖" class="m-sharebar-mobile-btn__img">
    </button>
    <span class="m-sharebar__preventReClicks" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ShareBar',
  props: {
    base: {
      type: String,
      required: true
    },
    dataId: {
      type: Number,
      required: true
    },
    dataTitle: {
      type: String,
      required: true
    },
    dataNext: {
      type: Object,
      required: true
    },
    sharebarFixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      host: 'https://www.ctwant.com',
      componentScreenWidth: 0,
      isShowShare: false,
      nextNewPopover: {
        show: false,
        style: {
          top: 0,
          left: 0
        }
      },
      qrcodePopover: {
        show: false,
        style: {
          top: 0,
          left: 0
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'WIDTH_PAD',
      'screenWidth',
      'isPlayingStream'
    ])
  },
  mounted() {
    this.host = window.location.origin
    this.componentScreenWidth = this.screenWidth || window.screen.width

    if (this.pageScreenWidth > this.WIDTH_PAD) {
      this.isShowShare = true
    }
  },
  methods: {
    sharePopup(type) {
      const social = {
        line: '//line.naver.jp/R/msg/text/?',
        facebook: '//www.facebook.com/sharer/sharer.php?u=',
        twitter: 'https://twitter.com/intent/tweet?url='
      }
      const utm = {
        line: '?utm_source=share&utm_medium=line',
        facebook: '?utm_source=share&utm_medium=fb',
        twitter: '?utm_source=share&utm_medium=twitter'
      }
      window.open(`${social[type]}${this.host}${this.$route.path}${utm[type]}`, type, 'width=600,height=500,scrollbars=yes')
    },
    onCopy() {
      this.$notyf.success('成功複製網址！')
    },
    onCopyError() {
      this.$notyf.error('複製網址失敗')
    },
    wechatShare(e) {
      if (this.componentScreenWidth > this.WIDTH_PAD) {
        this.showPopover(e, 'qrcodePopover')
      }
    },
    wechatShareMobile() {
      if (this.componentScreenWidth <= this.WIDTH_PAD) {
        this.$copyText(`${this.host}${this.$route.path}?utm_source=share&utm_medium=微信`).then((e) => {
          this.$notyf.success('複製連結成功！快打開微信跟好友分享吧')
        }, (e) => {
          this.$notyf.error('複製連結失敗')
        })
      }
    },
    nextNews(e) {
      if (this.componentScreenWidth > this.WIDTH_PAD) {
        this.showPopover(e, 'nextNewPopover')
      }
    },
    showPopover(e, popover) {
      const target = e.target.getBoundingClientRect()
      this[popover].show = true
      this[popover].style.top = `${target.top + target.height / 2}px`
      this[popover].style.left = `${target.left + target.width + 17}px`
    },
    async mobileShare() {
      if (navigator.share) {
        try {
          await navigator.share({
            title: this.dataTitle,
            text: this.dataTitle,
            url: `${this.host}${this.$route.path}?utm_source=share&utm_medium=mobile`
          })
        } catch (error) {
        }
      } else {
        this.isShowShare = !this.isShowShare
      }
    }
  }
}
</script>

<style lang="scss">
@import '~/assets/scss/modules/_sharebar';
</style>
